module.exports = __webpack_public_path__ + "static/media/maintenance.0d66e29b.svg";